<template>
  <v-text-field
    v-if="!disableShow"
    variant="outlined"

    color="secondary"
    :label="required ? '*' + _label : _label"
    :placeholder="placeholder"
    :prepend-inner-icon="icon"
    :name="fieldKey"
    :type="show ? 'text' : 'password'"
    :hint="hint"
    :error-messages="errorMessages"
    :browser-autocomplete="autocomplete"
    :model-value="modelValue"
    :rules="[requireRule]"

    :append-inner-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
    :disabled="disabled"

    @keyup.enter="$emit('keyup-enter')"
    @update:model-value="$emit('update:model-value', $event)"

    @click:append-inner="show = !show"
  />
  <v-text-field
    v-else
    variant="outlined"

    color="secondary"
    :label="required ? '*' + _label : _label"
    :placeholder="placeholder"
    :prepend-inner-icon="icon"
    :name="fieldKey"
    type="password"
    :hint="hint"
    :error-messages="errorMessages"
    :browser-autocomplete="autocomplete"
    :value="modelValue"
    :rules="[requireRule]"

    :disabled="disabled"
    @keyup.enter="$emit('keyup-enter')"

    @update:model-value="$emit('update:model-value', $event)"
  />
</template>

<script>
  import InputMixin from './InputMixin'

  export default {
    mixins: [InputMixin],
    props: {
      autocomplete: { type: String, default: 'new-password' },
      placeholder: {
        type: String,
        default: ''
      },
      disableShow: Boolean,
      label: {
        type: String,
        default: ''
      }
    },
    emits: ['keyup-enter', 'update:model-value'],
    data: () => ({
      show: false
    }),
    computed: {
    _label () {
      if (this.label === '') {
        return ''
      }
      if (this.label) {
        return this.label
      } else {
        return this.$t('User.Password')
      }
    }
    },
    methods: {
      requireRule (value) {
        return this.required ? !!value || this.$t('Required') : true
      }
    }
  }
</script>
